import {
  Typography,
  TableRow,
  TableCell,
  Switch,
  IconButton,
  Tooltip,
  Stack,
} from '@mui/material';
import { hasPermission } from '../../../../../configs/functions';
import {
    EditIcon,
    TrashIcon,
    FacialRecognitionIconChecked,
    FacialRecognitionIconWarning,
    LockIconChecked,
    LockIconWarning,
    FacialRecognitionIconError, GoodPincodeIcon, PasswordResetIcon
} from '../../../../common/Icons';
import { AddModerator, LockReset, Visibility } from '@mui/icons-material';

export function CollaboratorRow({
                                    user,
                                    actionsAllowed,
                                    isPendingUpdate,
                                    isMaxUsersAdmin,
                                    handleOpenViewModal,
                                    handleOpenEditForm,
                                    handleUpdateStatus,
                                    handleOpenDeleteDialog,
                                    handleOpenDialogResetUser,
                                    handleOpenEditTurnAdminForm,
                                    handleOpenDialogFirstAccess,
                                    passwordRef,
                                    setPrimeiroAcesso,
                                }) {
  const userIsPrimeiroAcesso = user?.pendencias.includes('primeiro_acesso');

  return (
    <TableRow key={user.id}>
      <TableCell>{user.matricula}</TableCell>
      <TableCell><Typography noWrap variant='body2'>{user?.nome}</Typography></TableCell>
      <TableCell>
        <Typography variant='subtitle2' key={user.empresa.id_empresa}>{user?.empresa?.fantasyName}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant='subtitle2'>{user?.grupo?.nome}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant='subtitle2'>{user?.funcao?.nome}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant='subtitle2'>{user?.centroCusto?.nome}</Typography>
      </TableCell>
      <TableCell>
        <Switch
          checked={!!user.status}
          onChange={handleUpdateStatus}
          disabled={!hasPermission(["admin", "admin_pessoas", "update_pessoas"]) || !actionsAllowed || isPendingUpdate}
        />
      </TableCell>
      <TableCell align='right'>
        <Stack direction="row" justifyContent='space-around'>
          {user.hasBioface && user.biofaceIdentifier.includes('/9j/') ? (
            <Tooltip title="Biometria facial cadastrada" placement="top">
              <IconButton sx={{ cursor: 'default', width: 44 }}>
                <FacialRecognitionIconChecked />
              </IconButton>
            </Tooltip>
          ) : (
            // se existe biometria, mas a mesma não é uma imagem válida em base64, então exibir como erro
            !user.hasBioface
              ?
              <Tooltip title='Biometria facial pendente' placement="top">
                <IconButton onClick={() => actionsAllowed && handleOpenEditForm()} sx={{ width: 44 }}>
                  <FacialRecognitionIconWarning />
                </IconButton>
              </Tooltip>
              : <Tooltip title='Biometria facial incorreta' placement="top">
                <IconButton onClick={() => handleOpenEditForm()} sx={{ width: 44 }}>
                  <FacialRecognitionIconError />
                </IconButton>
              </Tooltip>
          )}

          {(!user.senha) || (user.senha && userIsPrimeiroAcesso) ? (
            <Tooltip title="Senha pendente" placement="top">
              <IconButton sx={{ cursor: 'default' }}>
                <LockIconWarning />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Senha cadastrada" placement="top">
              <IconButton sx={{ cursor: 'default' }}>
                <LockIconChecked />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </TableCell>
      <TableCell sx={{ minWidth: 225 }} align='right'>
        {hasPermission(["admin", "admin_pessoas", "view_pessoas"]) &&
          <IconButton
            aria-label="Visualizar"
            onClick={() => handleOpenViewModal()}
          >
            <Visibility color="primary" />
          </IconButton>
        }

        {hasPermission(["admin", "admin_pessoas", "update_pessoas"]) &&
          <>
            {actionsAllowed && (
              <IconButton
                aria-label="Editar"
                onClick={() => handleOpenEditForm()}
              >
                <EditIcon />
              </IconButton>
            )}

            {/*<Tooltip title={userIsPrimeiroAcesso ? 'Usuário ainda não cadastrou Credenciais' : 'Resetar Credenciais'}>*/}
            {/*  <IconButton*/}
            {/*    aria-label="Resetar Credenciais"*/}
            {/*    onClick={() => handleOpenDialogResetUser(true)}*/}
            {/*  >*/}
            {/*    <LockReset color={userIsPrimeiroAcesso ? 'disabled' : 'primary'} />*/}
            {/*  </IconButton>*/}
            {/*</Tooltip>*/}

              <Tooltip title={!userIsPrimeiroAcesso ? 'Resetar Credenciais' : 'Definir primeiro acesso'}>
                  <IconButton
                      aria-label="Cadastrar Senha"
                      onClick={() => {
                          if (!userIsPrimeiroAcesso) {
                              handleOpenDialogResetUser(true);
                          } else {
                              handleOpenDialogFirstAccess(true);
                          }
                      }}
                  >
                      {!userIsPrimeiroAcesso ? (
                          <GoodPincodeIcon />
                      ) : (
                          <PasswordResetIcon />
                      )}
                  </IconButton>
              </Tooltip>

            {actionsAllowed && (
              <Tooltip title={isMaxUsersAdmin ? 'Limite de Administradores atingido' : 'Alterar para Administrador'}>
                <IconButton
                  aria-label="Alterar para Administrador"
                  onClick={() => {
                    if (isMaxUsersAdmin) return;
                    handleOpenEditTurnAdminForm()
                  }}
                >
                  <AddModerator color={isMaxUsersAdmin ? 'disabled' : 'primary'} />
                </IconButton>
              </Tooltip>
            )}
          </>
        }

        {hasPermission(["admin", "admin_pessoas", "delete_pessoas"]) && actionsAllowed &&
          <IconButton
            aria-label="Excluir"
            onClick={() => handleOpenDeleteDialog()}
            disabled={!user.status}
            sx={{ filter: !user.status ? "grayscale(1) brightness(1.4)" : "" }}
          >
            <TrashIcon />
          </IconButton>
        }
      </TableCell>
    </TableRow>
  )
}